export default __webpack_public_path__ + "static/media/Slide10.79789415.PNG";